import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { Dimensions, View } from "react-native";
import Svg, { Path, Defs, LinearGradient as SvgLinearGradient, Stop } from "react-native-svg";

const GradientHeader = (props) => {
  const { height = 280, waveHeight = 40, ...restProps } = props;
  const screenWidth = Dimensions.get("window").width;

  return (
    <View style={{ position: "absolute", top: 0, left: 0, right: 0 }}>
      <LinearGradient
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        colors={["#72C6EF", "#56A1D1", "#367CB4"]}
        style={{
          height: height - waveHeight,
          width: screenWidth,
        }}
        {...restProps}
      />
      <Svg
        width={screenWidth}
        height={waveHeight + 1}
        viewBox={`0 0 ${screenWidth} ${waveHeight + 1}`}
        style={{ position: "absolute", bottom: -height, transform: [{ scaleY: -1 }] }}
      >
        <Path
          d={`M0,${waveHeight} C${screenWidth * 0.25},${waveHeight * 0.3} ${screenWidth * 0.75},${waveHeight * 1.7} ${screenWidth},${waveHeight} L${screenWidth},0 L0,0 Z`}
          fill="url(#gradient)"
        />
        <Defs>
          <SvgLinearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <Stop offset="0%" stopColor="#72C6EF" />
            <Stop offset="50%" stopColor="#56A1D1" />
            <Stop offset="100%" stopColor="#367CB4" />
          </SvgLinearGradient>
        </Defs>
      </Svg>
    </View>
  );
};

export default GradientHeader;
